import React from "react"
import { Box, Flex } from "@theme-ui/components"
import { LanguageSwitcherContext } from "../locales/languageSwitcherContext"

const LanguageSwitcher = ({ mobile }) => {
  return (
    <LanguageSwitcherContext.Consumer>
      {({ activeLocale, paths }) => {
        return (
          <Flex
            as={"ul"}
            sx={{
              flexDirection: "row",
              right: 0,
              margin: 0,
              ml: mobile ? 0 : 3,
              listStyle: "none",
            }}
          >
            {paths
              .sort((a, b) => b.locale.localeCompare(a.locale))
              .map((link, index, array) => (
                <Flex as="li" key={index} sx={{ ml: mobile ? 0 : 0 }}>
                  <a
                    href={link.value}
                    style={{
                      whiteSpace: "nowrap",
                      display: "block",
                      borderRadius: "xs",
                      fontSize: "15px",
                      fontWeight: 500,
                      textTransform: "uppercase",
                      textDecoration: "none",
                      color: mobile
                        ? "white"
                        : activeLocale === link.locale
                        ? "#00793D"
                        : "#4A4A4A",
                    }}
                  >
                    {link.locale}
                  </a>
                  {!mobile && index < array.length - 1 && (
                    <span
                      style={{
                        color: "inherit",
                      }}
                    >
                      |
                    </span>
                  )}
                </Flex>
              ))}
          </Flex>
        )
      }}
    </LanguageSwitcherContext.Consumer>
  )
}

export default LanguageSwitcher
